<template>
  <div class="bottom-box">
    <div class="bottom-left">
      <el-card class="box-cards">
        <div slot="header" class="clearfix">
          <span>常用功能</span>
        </div>
        <div class="cards-content">
          <div class="application">
            <div
              :key="index"
              @click="jump(item.url,item.authBtn)"
              v-for="(item,index) in applicationData"
            >
              <img
                v-if="item.icon"
                :src="item.icon"
                alt
                style="width:1em;height:1em;margin-left:24px"
              />
              <icon-svg v-else name="ben"></icon-svg>
              <div>{{item.name}}</div>
            </div>
            <!-- <div style="border: 2px dotted #C2CDE2;justify-content:center">
                            <icon-svg name="add"></icon-svg>
                            <div> 添加常用链接</div>
            </div>-->
          </div>
        </div>
      </el-card>
    </div>
    <div class="bottom-right">
      <el-card class="box-cards">
        <div slot="header" class="clearfix">
          <span>常用链接</span>
        </div>
        <div class="cards-content">
          <div class="links">
            <div v-for="(item,index) in linkData" :key="index" class="link-box">
              <div style="width:48px;height:48px;margin-left:24px">
                <img v-if="item.icon" :src="item.icon" alt style="width:48px;height:48px" />
                <img v-else :src="getImgUrl(index)" alt />
              </div>
              <div @click="jumpLink(item.url,item.authBtn)">
                <span>{{item.name}}</span>
                <span>进入</span>
              </div>
            </div>
            <!-- <div style="border: 1px dotted #C2CDE2;justify-content:center">
                            <icon-svg name="add"> </icon-svg>
                            <div class="linkText">&nbsp;添加常用链接</div>
            </div>-->
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { findMenuItem } from "@/utils/index";
export default {
  data() {
    return {
      accessToken: "",
      bidId: ""
    };
  },
  props: ["applicationData", "linkData"],
  created() {
    this.accessToken = this.$cookie.get("access_token");
  },
  methods: {
    formatSrc(src) {
      let params = this.GetRequest(src);
      var getBase =
        src.indexOf("?") > -1 ? src.substring(0, src.indexOf("?") + 1) : src;
      for (var i in params) {
        let value = params[i];
        let variable = value.indexOf("${") > -1;
        if (value.indexOf("${") > -1 || value.indexOf("}") > -1) {
          value = value.replace("${", "");
          value = value.replace("}", "");
        }
        getBase += `&${i}=${variable ? this[value] : value}`;
      }
      console.log(getBase.replace("?&", "?"));
      console.log(src.indexOf("http"));
      let returnSrc = getBase.replace("?&", "?");
      console.log(returnSrc, "returnSrc");
      return returnSrc;
    },
    formatAppurl(url) {
      let params = [],obj={},
        h;
        let path
      let hash = url.slice(url.indexOf("?") + 1).split("&");
      if(url.indexOf("?")==-1){
        path=url
      }else{
        path=url.slice(0,url.indexOf("?"))
      }
     
      debugger
      for (let i = 0; i < hash.length; i++) {
        h = hash[i].split("="); //
        obj.key=h[0]
        obj.value=h[1]
        params[i] = obj;
        console.log(h);
      }
      params.push({key:"path",value:path});
      return params;
    },
    getImgUrl(index) {
      return require("@/assets/img/home/link_" + (Number(index) + 1) + ".png");
    },
    jumpLink(url, authBtn) {
      if (!this.hasBtnPermission(authBtn)) {
        this.$message.error("您无权限跳转该系统");
        return;
      }
      if (url) {
        url = this.formatSrc(url);
        window.open(url);
      }
    },
    async jump(pathurl, authBtn) {
     // let path = "";
    //  let queryObj={}
    //   if (pathurl) {
    //     let paramsList = this.formatAppurl(pathurl);
    //     path=paramsList[paramsList.length-1].value;
    //     for(let j=0;j<paramsList.length-1;j++){
    //         queryObj[paramsList[j].key]=paramsList[j].value
    //     }
    //   }
    
      if (!this.hasBtnPermission(authBtn)) {
        this.$message.error("您无权限跳转该页面");
        return;
      }

      //   if (path == "credit_exposal_list") {
      //     await findMenuItem(
      //       JSON.parse(sessionStorage.getItem("menuList")),
      //       "credit_mainInfo_list"
      //     );
      //     this.$router.push({
      //       path: path
      //     });
      //     return;
      //   }
      //   if (path == "/synthesize/superviseAndHandle") {
      //     await findMenuItem(
      //       JSON.parse(sessionStorage.getItem("menuList")),
      //       "digitCockpit"
      //     );
      //     this.$router.push({
      //       path: path
      //     });
      //     return;
      //   }
      await findMenuItem(JSON.parse(sessionStorage.getItem("menuList")), pathurl);
      this.$router.push({
        // path: "path",
        // query: queryObj
        path:pathurl
      });
    },
    GetRequest(href) {
      var url = href.substring(href.indexOf("?")); //获取url中"?"符后的字串
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
        }
      }
      return theRequest;
    }
  }
};
</script>
<style lang="scss" scoped>
.bottom-box {
  .box-cards {
    height: 100%;
  }
}
.bottom-left {
  width: 948px;
  margin-right: 24px;
  .application {
    display: flex;
    flex-wrap: wrap;
    & > div {
      width: 280px;
      height: 64px;
      background: #f4f6f9;
      border-radius: 2px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.65);
      display: flex;
      align-items: center;
      border: 1px solid transparent;
      margin-bottom: 28px;
      cursor: pointer;
      margin-right: 34px;
      &:nth-of-type(3n) {
        margin-right: 0;
      }
      &:hover {
        border-color: #1890ff;
        color: #1890ff;
      }
      .icon-svg {
        margin-left: 24px;
      }
      div {
        margin-left: 10px;
      }
    }
  }
}
.bottom-right {
  flex: 1;
  .links {
    display: flex;
    flex-wrap: wrap;
    .linkText:hover {
      color: #1890ff;
    }
    & > div {
      width: calc(50% - 8px);
      height: 76px;
      background: #ffffff;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
      border-radius: 2px;
      margin-right: 16px;
      margin-bottom: 16px;
      &:nth-of-type(2n) {
        margin-right: 0px;
      }
      display: flex;
      align-items: center;
      border: 1px solid transparent;
    }
  }
  .link-box {
    cursor: pointer;
    &:hover {
      & > div:nth-of-type(2) {
        span:nth-of-type(2) {
          color: #1890ff;
        }
      }
    }
    & > div {
      &:nth-of-type(1) {
        margin-right: 16px;
        margin-left: 24px;
      }
      &:nth-of-type(2) {
        span {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.85);
          display: block;
        }
        span:nth-of-type(1) {
          font-weight: 600;
          margin-bottom: 11px;
        }
        span:nth-of-type(2) {
          color: rgba(0, 0, 0, 0.45);
        }
      }
    }
  }
}
@media screen and (max-width: 1660px) {
  .bottom-left {
    width: 665px;
    .application {
      & > div {
        margin-right: 34px !important;
        &:nth-of-type(2n) {
          margin-right: 0px;
        }
      }
    }
  }
}
</style>